import { useQuery } from "@tanstack/react-query";
import brandCore from "../core/brand.core";

interface UseGetBrandOptions {
  staleTime?: number;
}

export default function useGetBrand(brandId: string, option?: UseGetBrandOptions) {
  return useQuery({
    queryKey: ["brand", brandId],
    queryFn: (context) => brandCore.getBrand(context.queryKey[1]),
    staleTime: option?.staleTime ?? undefined,
  });
}
